<template>
  <div class="drone-page" ref="droneViews">
    <!-- 无线盒子、天气数据dom -->
    <div class="drone-device-compass-view">
      <div class="left-area" :class="toggleClassName">
        <droneListView
          v-if="showBoxDom"
          ref="dronView"
          class="device"
          :currentIndex="droneIndex"
          :boxList="boxList"
          pageType="device"
          @subDetail="subDetailHandler"
        />
        <weatherView v-if="showWeatherDom" :weatheInfo="weatherModData" class="weather-box" />
      </div>

      <div class="right-area">
        <Header :isUnfold="isUnfold" @toggleBoxView="toggleVisibility" />
      </div>
    </div>

    <!-- 传感器 dom-->
    <div class="sensor-data-view">
      <sensorListView
        :name="droneName"
        :seneorData="seneorList"
        :seneorGrade="seneorGradeObj"
        @chooseSensorIndex="changeSensorIndexHandler"
      />
    </div>

    <MapScene
      :initMod="initMod"
      :name="droneName"
      :sensorIndex="sensorIndex"
      :droneIndex="droneIndex"
      :address="locationData"
      :sensorData="seneorList"
      :seneorGrade="seneorGradeObj"
      :realLineData="realTimeData"
      :upPositionFlag="upDronePositionFlag"
    />
  </div>
</template>

<script>
let pmNameObj = {
  pm1: 'PM1.0 浓度',
  pm25: ' PM2.5',
  pm10: 'PM10',
  pmLevel: 'pm等级',
  pm1Atm: 'PM1.0 浓度 ',
  pm25Atm: ' PM2.5 浓度',
  pm10Atm: 'PM10 浓度 ',
  parCount1: '0.3以上颗粒数',
  parCount2: '0.5以上颗粒数',
  parCount3: '1.0以上颗粒数',
  parCount4: '2.5以上颗粒数',
  parCount5: '5.0以上颗粒数',
  parCount6: '10以上颗粒数',
  pmFault: '颗粒传感器故障'
};
import Header from './components/right-top-bar/index.vue';
import MapScene from './components/map3D/MapScene.vue';
import droneListView from './components/droneList.vue';
import weatherView from './components/weatherInfoView.vue';
import sensorListView from './components/sensorView.vue';

import mixins from '../utils/mixins';
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import { droneRealTimeServer, getSensorsGradeServer } from '@/api/drone';
import { toBmapPos2 } from '@/utils/bmapUtil';
import { isEmpty } from '@/utils/is';

export default {
  mixins: [mixins],
  components: {
    Header,
    droneListView,
    sensorListView,
    weatherView,
    MapScene
  },
  computed: {
    ...mapState('socket', ['deviceSNMap'])
  },

  watch: {
    deviceList: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (isEmpty(newVal)) return;
          this.boxList = newVal;
          this.showBoxDom = true;
          this.subTimer = setTimeout(() => {
            this.subDetailHandler(this.boxList[0], 0);
          }, 1000 * 3);
        }
      }
    }
  },
  sockets: {
    '/socket/detail'(res) {
      this.updateData(res);
    }
  },
  data() {
    return {
      droneName: '',
      droneIndex: 0,
      initMod: false,
      locationData: {
        latitude: '',
        longitude: '',
        height: ''
      },
      upDronePositionFlag: false,
      sensorIndex: 0,
      seneorGradeObj: null,

      weatherModData: {},

      toggleClassName: '',
      isUnfold: true,
      activeList: [],

      showBoxDom: false,
      showWeatherDom: false,

      boxList: [], // 无线盒子
      seneorList: [], // 实时数据

      realTimeData: [],
      recordAllData: [],
      recordVisible: false,
      recordTime: []
    };
  },
  provide() {
    return {
      getDroneCtx: () => this,
      getDroneEl: () => this.$refs.droneViews,
      deviceTree: this.deviceTree,
      devicesSourseMap: this.devicesSourseMap
    };
  },

  mounted() {
    this.testIndex = 0;
    this.initData();
    this.currentBoxSn = '';
    this.snList = [];
    this.loadSensorGradeHandler();

    localStorage.getItem('showTaskDialogFlag');

    let taskFlag = localStorage.getItem('showTaskDialogFlag');
    if (taskFlag) {
      let time = JSON.parse(localStorage.getItem('taskTime'));
      this.showTaskViewHandle(time);
    }
  },
  beforeDestroy() {
    if (this.subTimer) clearTimeout(this.subTimer);
    this.unsubscribeDetail();
  },

  methods: {
    ...mapActions('mqtt', ['subDeviceDetail', 'unsubDeviceDetail']),
    initData() {
      this.RG04Obj = {};
      this.RG04Data = [];
      this.GM606Obj = {};
      this.GM606Data = [];
      this.PMS6003Data = [];
      this.NRHM01Obj = {};
      this.NRHM01Data = [];
      this.mn606Obj = {};
      this.mn606Data = [];
      this.realData = [];
    },

    subDetailHandler(val, droneIndex) {
      let { state } = this.deviceSNMap[val.sn];

      this.snList = [];
      val.wirelessBoxConfDtoList.forEach(item => {
        this.snList.push(item.boxSn || item.sn);
      });

      sessionStorage.setItem('drone-sensor-sn', JSON.stringify(this.snList));

      if (state === undefined) {
        this.$message.warning('当前设备不在线，待上线后重试');
        return;
      }
      this.currentBoxSn = val.sn;
      this.droneName = val.name;
      this.droneIndex = droneIndex;

      this.subDeviceDetail({ sn: this.snList });
    },
    unsubscribeDetail() {
      if (!this.snList.length) return;
      this.unsubDeviceDetail({ sn: this.snList });
    },
    async updateData(res) {
      //   console.log('res: ', res);
      let { sn, deviceType, mods, beginTime, latitude, longitude, altitude: height } = res;

      //   if (latitude === 0 || longitude === 0) return;

      this.upDronePositionFlag = false;

      let { weatherMod } = mods;

      this.weatherModData = null;
      this.weatherModData = weatherMod;
      this.showWeatherDom = true;

      const potions = toBmapPos2({
        coordinate: [longitude, latitude]
      });
      this.locationData = {
        longitude: potions[0],
        latitude: potions[1],
        height: height ? height : 500
      };

      setTimeout(() => {
        this.upDronePositionFlag = true;
      }, 100);

      switch (deviceType) {
        case 'GM606':
          this.upGM606DataHandler(sn, mods.gm606Mod, beginTime, deviceType);
          break;
        case 'RG04':
          this.upRG04ModHandler(sn, mods.nuclearMod, beginTime, deviceType);
          break;
        case 'PMS6003':
          this.upPMS6003ModHandler(sn, mods.smokeMod, beginTime, deviceType);
          break;
        case 'NRH-M01':
          this.upNRHM01ModHandler(sn, mods.nrhM01Mod, beginTime, deviceType);
          break;
        case 'MN606':
          this.upMN606ModHandler(sn, mods.mn606Mod, beginTime, deviceType);
          break;
        default:
          break;
      }
      setTimeout(() => {
        this.packageSensorViewDataHandler();
        this.initMod = true;
      }, 100);
    },
    upGM606DataHandler(sn, val, time, deviceType) {
      let newGM606Data = [];
      this.GM606Data = [];
      val.sensors.forEach(item => {
        item.beginTime = time;
        item.deviceType = deviceType;
        item.sn = sn;
      });
      this.GM606Obj[sn] = val.sensors;
      Object.keys(this.GM606Obj).forEach(key => {
        newGM606Data = [...newGM606Data, ...this.GM606Obj[key]];
      });
      this.GM606Data = newGM606Data;

      newGM606Data.forEach(item => {
        item.latitude = this.locationData.latitude;
        item.longitude = this.locationData.longitude;
        item.height = this.locationData.height;

        this.recordAllData.push(item);
      });
    },

    upRG04ModHandler(sn, val, beginTime, deviceType) {
      //   state 0 正常 1预警  2报警 3恢复
      let obj = {
        beginTime,
        deviceType,
        value: val.radDose,
        name: '剂量率',
        unitName: 'μSv/h',
        alarmState: val.state,
        latitude: this.locationData.latitude,
        longitude: this.locationData.longitude,
        height: this.locationData.height
      };

      if (val.state == 3) {
        obj.alarmState = 0;
      }
      val = { ...obj, ...val };

      this.recordAllData.push(obj);

      let NRHM01Data = [];
      this.RG04Obj[sn] = [val];
      Object.keys(this.RG04Obj).forEach(key => {
        NRHM01Data = [...NRHM01Data, ...this.RG04Obj[key]];
      });
      this.RG04Data = NRHM01Data;
    },

    upPMS6003ModHandler(sn, val, beginTime, deviceType) {
      let newPMS6003Data = [];
      let showPmDto = ['pm25', 'pm10'];
      showPmDto.forEach(key => {
        let obj = {
          name: key,
          showName: Object.keys(pmNameObj).includes(key) ? pmNameObj[key] : key,
          value: val.pmDto[key],
          deviceType,
          beginTime,
          alarmState: 0,
          unitName: 'µg/m³',
          latitude: this.locationData.latitude,
          longitude: this.locationData.longitude,
          height: this.locationData.height
        };
        newPMS6003Data.push(obj);
        this.recordAllData.push(obj);
      });
      this.PMS6003Data = newPMS6003Data;
    },
    upNRHM01ModHandler(sn, val, beginTime, deviceType) {
      let obj = {
        beginTime,
        deviceType: deviceType,
        value: val.radonConcentration,
        name: '氡气/Rn',
        unitName: 'Bq/m³',
        alarmState: val.state,
        latitude: this.locationData.latitude,
        longitude: this.locationData.longitude,
        height: this.locationData.height
      };
      val = { ...val, ...obj };

      if (val.state == 3) {
        obj.alarmState = 0;
      }

      this.recordAllData.push(obj);

      let NRHM01Data = [];
      this.NRHM01Obj[sn] = [val];
      Object.keys(this.NRHM01Obj).forEach(key => {
        NRHM01Data = [...NRHM01Data, ...this.NRHM01Obj[key]];
      });
      this.NRHM01Data = NRHM01Data;
    },

    upMN606ModHandler(sn, val, time, deviceType) {
      let newMn606Data = [];
      this.mn606Data = [];
      let otherInfoList = [
        // { key: 'temp', name: '温度', unitName: '℃' },
        // { key: 'humidity', name: '相对湿度', unitName: '%' },
        { key: 'fanStatus', name: '风扇运行状态', unitName: '' },
        { key: 'pm1', name: 'pm1.0浓度', unitName: 'ug/m³' },
        { key: 'pm25', name: 'pm2.5浓度', unitName: 'ug/m³' },
        { key: 'pm10', name: 'pm10浓度', unitName: 'ug/m³' },
        { key: 'pm03Num', name: '大于0.3个数', unitName: '个/0.1L' },
        { key: 'pm05Num', name: '大于0.5个数', unitName: '个/0.1L' },
        { key: 'pm1Num', name: '大于1.0个数', unitName: '个/0.1L' },
        { key: 'pm25Num', name: '大于2.5个数', unitName: '个/0.1L' },
        { key: 'pm5Num', name: '大于5个数', unitName: '个/0.1L' },
        { key: 'pm10Num', name: '大于10个数', unitName: '个/0.1L' }
      ];
      let fanStatusUnit = {
        0: '停止',
        1: '1档',
        2: '2档',
        3: '3档'
      };
      otherInfoList.forEach(item => {
        item.alarmState = 0;
        item.beginTime = time;
        item.value = val[item.key];
        if (item.key === 'fanStatus') {
          item.showValue = fanStatusUnit[val[item.key]];
        }
      });
      val.sensorDataList.forEach(item => {
        item.beginTime = time;
        item.deviceType = deviceType;
        item.sn = sn;
      });
      this.mn606Obj[sn] = val.sensorDataList;
      Object.keys(this.mn606Obj).forEach(key => {
        newMn606Data = [...newMn606Data, ...this.mn606Obj[key]];
      });
      this.mn606Data = [...newMn606Data, ...otherInfoList];
      newMn606Data.forEach(item => {
        item.latitude = this.locationData.latitude;
        item.longitude = this.locationData.longitude;
        item.height = this.locationData.height;
        this.recordAllData.push(item);
      });
    },

    packageSensorViewDataHandler() {
      this.seneorList = [
        ...this.RG04Data,
        ...this.GM606Data,
        ...this.PMS6003Data,
        ...this.NRHM01Data,
        ...this.mn606Data
      ];
    },
    rightBtnToggleHandle(i) {
      if (isEmpty(this.boxList)) return;
      this.activeList = [];
      this.activeList.push(i);
    },

    changeSensorIndexHandler(val, index) {
      this.sensorIndex = index;
      if (this.realData) {
        this.realTimeData = [];
        this.disposeResRealTimeDataHandler(this.realData);
      }
    },
    toggleVisibility() {
      this.isUnfold = !this.isUnfold;
      this.toggleClassName = this.isUnfold ? 'device-show' : 'device-hidden';
    },
    loadBoxRealTimeBoxHandler() {
      droneRealTimeServer(this.currentBoxSn).then(res => {
        if (isEmpty(res.data)) return;

        this.realData = [];
        for (const i in res.data) {
          this.realData = this.realData.concat(res.data[i]);
        }
        this.realData = this.realData.sort((a, b) => {
          return a.beginTime - b.beginTime;
        });
        this.disposeResRealTimeDataHandler(this.realData);
      });
    },
    disposeResRealTimeDataHandler(data) {
      this.realGM606Data = [];

      const handler = {
        gm606Mod: mod => {
          return mod.sensors.reduce((map, e) => {
            map[e.code] = e.value;
            return map;
          }, {});
        },
        nuclearMod: mod => {
          return {
            剂量率: mod.radDose
          };
        },
        smokeMod: mod => {
          return Object.keys(mod.pmDto).reduce((map, key) => {
            map[key] = mod.pmDto[key];
            return map;
          }, {});
        },
        nrhM01Mod: mod => {
          return { 氡气: mod.radonConcentration };
        }
      };

      const res = data.reduce((map, item) => {
        const { mods, beginTime } = item;
        const pos = [item.longitude, item.latitude, 50];

        if (beginTime >= this.recordAllData[0].beginTime) return map;

        Object.keys(mods).forEach(key => {
          if (!map[beginTime]) map[beginTime] = {};
          Object.assign(map[beginTime], handler[key]?.(mods[key]) || {});
        });

        map[beginTime].position = pos;
        map[beginTime].beginTime = beginTime;
        return map;
      }, {});

      this.realTimeData = Object.values(res).sort((a, b) => a.beginTime - b.beginTime);
    },
    showTaskViewHandle(time) {
      localStorage.setItem('taskTime', JSON.stringify(time));
      localStorage.setItem('showTaskDialogFlag', true);
      this.recordTime = time;
      this.activeList = [];
      this.recordVisible = true;
      this.$nextTick(() => {
        this.$refs.dialogUpdate.visible = true;
      });
    },
    loadSensorGradeHandler() {
      let sensorType = ['GM606', 'RG04', 'PMS6003', 'NRH-M01', 'MN606'];
      getSensorsGradeServer(sensorType).then(res => {
        this.seneorGradeObj = res.data;
        // this.seneorGradeObj = {};
      });
    }
  }
};
</script>

<style scoped lang="scss">
.drone-page {
  position: relative;
  height: 100%;
  width: 100%;

  .drone-device-compass-view {
    display: flex;
    align-items: center;
    position: absolute;
    // pointer-events: none;
    padding: 0 20px;
    box-sizing: border-box;
    z-index: 6;
    width: 100%;
    height: 100px;

    .left-area {
      width: 90%;
      height: 100%;
      display: flex;
      align-items: center;

      -webkit-backdrop-filter: blur(4px);
      backdrop-filter: blur(4px);
      .device {
        width: 75%;
        height: 100%;
        overflow: hidden;
        pointer-events: all;
      }

      .weather-box {
        width: 25%;
        box-sizing: border-box;
        height: 100%;
      }
    }

    .device-show {
      width: 90%;
      height: 100%;
      overflow: hidden;
      animation: slide-down 0.5s ease forwards;
    }

    .device-hidden {
      -webkit-backdrop-filter: blur(0);
      backdrop-filter: blur(0);
      width: 90%;
      overflow: hidden;
      animation: slide-up 0.5s ease forwards;
    }

    .right-area {
      width: 10%;
      padding: 20px;
      box-sizing: border-box;
      pointer-events: all;
      flex: 1;
      height: 100%;
      display: flex;
    }

    @keyframes slide-down {
      from {
        // height: 140px;
        transform: translateY(-60px);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }

    @keyframes slide-up {
      from {
        // height: 140px;
        transform: translateY(0);
        opacity: 1;
      }
      to {
        transform: translateY(-60px);
        opacity: 0;
      }
    }
  }

  .sensor-data-view {
    --paddWidth: 20px;
    --rightBarWidth: 90px;
    --rightBarMargin: 15px;

    position: absolute;
    left: 20px;
    bottom: 20px;
    // 20 + 20 + 90+ 15
    // width: calc(100% - 145px);
    width: calc(
      100% - var(--paddWidth) - var(--paddWidth) - var(--rightBarWidth) - var(--rightBarMargin)
    );
    z-index: 6;
  }
}
</style>
